module.exports = __webpack_public_path__ + "static/media/github-logo.3e54ed15.png";